<template>
  <div v-if="showHandle(showTo)" class="report-picker">
    <div v-show="isLoading" class="preloader">
      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
    </div>
    <h3 class="report-picker__title">{{ title }}</h3>
    <div class="report-picker__buttons-container">
      <date-picker
        :format="format"
        :lang="$t('short lang')"
        :range="getRange(params)"
        :reportLoading="reportLoading"
        :confirm="true"
        class="report-picker__date-picker"
        value-type="format"
        v-model="dateRange"
        @change="handleDatePickerChange"
      />
      <button
        class="button filled report-picker__button report-picker__button_margin"
        @click="$emit('buttonClick', 'pdf', dateRange, uri, params)"
      >
        {{ $t("download") }} PDF
      </button>
      <!--      <button-->
      <!--        class="button filled report-picker__button"-->
      <!--        @click="$emit('buttonClick', 'xls', dateRange, uri, params)"-->
      <!--      >-->
      <!--        {{ $t("download") }} XLS-->
      <!--      </button>-->
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { HalfCircleSpinner } from "epic-spinners";
import user from "@/store/modules/user";

export default {
  props: {
    format: {
      type: String,
      default: "DD.MM.YYYY"
    },
    dateRange: {
      type: DatePicker
    },
    title: {
      type: String,
      required: true
    },
    range: {
      type: Boolean,
      required: true
    },
    uri: {
      type: String,
      required: true
    },
    buttonClick: {
      type: Function
    },
    params: {
      type: Array,
      required: true
    },
    reportLoading: {
      type: Boolean
    },
    showTo: {
      type: String
    }
  },
  components: {
    "date-picker": DatePicker,
    spinner: HalfCircleSpinner
  },
  computed: {
    isLoading() {
      return this.reportLoading;
    }
  },
  methods: {
    showHandle(type) {
      if (
        (type === "VIP" && user.state.isUserVIP == true) ||
        (type === "FHS" && user.state.isUserVIP == false)
      ) {
        return true;
      }
      return false;
    },
    handleDatePickerChange() {
      // console.log("Date range has been selected");
    },
    getRange(params) {
      let list = [];
      params.map(function(value) {
        if (value.id === "bDate" || value.id === "eDate") {
          list.push(value.id);
        }
      });
      if (list.length > 1) {
        return true;
      }
      return false;
    },
    getLabel(label) {
      if (label.toLowerCase().indexOf("ru:") !== -1) {
        return "Уведомления о выплате дохода по ЦБ";
      }
      return label;
    }
  }
};
</script>

<style scoped>
.report-picker {
  margin-bottom: 40px;
}

.report-picker__title {
  font-size: 24px;
  font-weight: normal;
  color: #222c44;
}

.report-picker__buttons-container {
  margin-top: 21px;
  display: flex;
  align-items: center;
}

.report-picker__date-picker {
  width: 207px;
}

.report-picker__button {
  height: 34px;
  margin-left: 17px;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
}

.report-picker__button_margin {
  margin-left: 34px;
}
</style>
